@if (facade.isLoading()) {
<div class="d-flex flex-grow-1 justify-content-center align-items-center">
  <av-loading-item icon="admin_panel_settings" textKey="app.reports.entra_admin_roles.loading" />
</div>
} @else {
<div class="reports-page px-2 pt-3 pb-2">
  <div class="d-flex justify-content-end mb-3">
    <button mat-flat-button color="primary" (click)="exportAllCsv()">
      <mat-icon>download</mat-icon>
      {{ 'app.reports.entra_admin_roles.export_all_csv' | translate }}
    </button>
  </div>

  <!-- KPI tiles -->
  <div class="row g-3 mb-3">
    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12">
      <app-report-kpi-tile icon="badge" labelKey="app.reports.dashboard.privileged_identities"
        [value]="facade.privilegedIdentityCount()" severity="info"
        (tileClick)="openPrivilegedIdentitiesDialog()" />
    </div>
    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12">
      <app-report-kpi-tile icon="admin_panel_settings" labelKey="app.reports.dashboard.global_administrators"
        [value]="facade.globalAdminCount()" [severity]="facade.globalAdminWarning() ? 'warning' : 'info'"
        [warning]="facade.globalAdminWarning()" (tileClick)="openGlobalAdminDialog()" />
    </div>
    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12">
      <app-report-kpi-tile icon="verified_user" labelKey="app.reports.entra_admin_roles.permanent_assignments"
        [value]="facade.permanentCount()" severity="neutral"
        (tileClick)="openSectionByKey('permanentUserAssignments')" />
    </div>
    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12">
      <app-report-kpi-tile icon="schedule" labelKey="app.reports.entra_admin_roles.eligible_assignments"
        [value]="facade.eligibleCount()" severity="neutral"
        (tileClick)="openSectionByKey('eligibleUserAssignments')" />
    </div>
    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12">
      <app-report-kpi-tile icon="no_accounts" labelKey="app.reports.dashboard.disabled_with_roles"
        [value]="facade.disabledWithRoles().length" severity="error"
        (tileClick)="openDisabledWithRolesDialog()" />
    </div>
    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12">
      <app-report-kpi-tile icon="group" labelKey="app.reports.entra_admin_roles.group_assignments"
        [value]="facade.groupAssignments().length" severity="neutral"
        (tileClick)="openSectionByKey('groupAssignments')" />
    </div>
    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12">
      <app-report-kpi-tile icon="business" labelKey="app.reports.entra_admin_roles.service_principal_assignments"
        [value]="facade.servicePrincipalAssignments().length" severity="neutral"
        (tileClick)="openSectionByKey('servicePrincipalAssignments')" />
    </div>
  </div>

  <!-- Charts -->
  <div class="row g-3 mb-3">
    <div class="col-xl-7 col-lg-6 col-md-12">
      <app-report-chart-card titleKey="app.reports.dashboard.role_bar_title" [options]="roleBarOptions()" />
    </div>
    <div class="col-xl-5 col-lg-6 col-md-12">
      <app-report-chart-card titleKey="app.reports.dashboard.assignment_type_donut_title"
        [options]="assignmentTypeDonutOptions()" (segmentClick)="openSectionByKey($event)" />
    </div>
  </div>

  <!-- PIM activity feed -->
  <div class="pim-activity-feed">
    <div class="d-flex justify-content-between align-items-center feed-header">
      <span class="feed-title">{{ 'app.reports.dashboard.pim_activity_feed' | translate }}</span>
      <button mat-button (click)="openSectionByKey('pimAuditLogs')">
        {{ 'app.reports.dashboard.view_all' | translate }}
      </button>
    </div>
    @if (recentActivityFeed().length > 0) {
    <div class="feed-list">
      @for (entry of recentActivityFeed(); track $index) {
      <div class="feed-row d-flex align-items-center">
        <span class="feed-status-chip" [class.status-failure]="isFailureStatus(entry.status)"
          [class.status-success]="!isFailureStatus(entry.status)">
          {{ entry.status }}
        </span>
        <span class="feed-user">{{ entry.user }}</span>
        <span class="feed-role">{{ entry.roleName }}</span>
        <span class="feed-date">{{ entry.activityDateTime }}</span>
      </div>
      }
    </div>
    } @else {
    <div class="feed-empty d-flex flex-column align-items-center justify-content-center">
      <mat-icon>history_toggle_off</mat-icon>
      <span>{{ 'app.reports.dashboard.feed_empty' | translate }}</span>
    </div>
    }
  </div>
</div>
}
